import ServiceCRUD from '../../../../../services/ServiceCRUD';

class Protocol extends ServiceCRUD {
  constructor() {
    super('protocols/count/user');
  }
}

export default new Protocol();
